import { IApplicationState } from '../../types/redux';

export const selectDateSlideIndex = (state: IApplicationState): number => {
  return state.fullscreenGallery.dateSlideIndex || 0;
};
